import parseQueryString from "@insite/client-framework/Common/Utilities/parseQueryString";
import { ExternalProviderLinkModel } from "@insite/client-framework/Services/IdentityService";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import loadExternalProviders from "@insite/client-framework/Store/Pages/SignIn/Handlers/LoadExternalProviders";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import styled, { css } from "styled-components";

/* Poolcorp Custom Code */
import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import LoadingOverlay, { LoadingOverlayProps } from "@insite/mobius/LoadingOverlay";
import getColor from "@insite/mobius/utilities/getColor";
import { contentSpacingStyles, sideBoxStyles } from "@store/theme/common/mixins";
import { getLoadingOverlayProps } from "@store/theme/common/props/loadingOverlay";
import { TYPOGRAPHY } from "@store/theme/design";
import getWidgetComponent from "@store/utilities/getWidgetComponent";
import { InfosBoxPartialProps } from "@store/Widgets/InfosBox";
import parse from "html-react-parser";

const InfosBox = getWidgetComponent("InfosBox");
/* Poolcorp Custom Code */

/* Poolcorp Moved Code - Fields */

const mapStateToProps = (state: ApplicationState) => {
    const parsedQuery = parseQueryString<{ returnUrl?: string; externalError?: string }>(location.search);

    return {
        /* Poolcorp Custom Code */
        externalProviders: state.pages.signIn.externalProviders
            ? state.pages.signIn.externalProviders.reduce(
                (result, value) => (result.some(x => x.caption === value.caption) ? result : [...result, value]),
                [] as ExternalProviderLinkModel[],
            )
            : undefined,
        externalError: parsedQuery.externalError,
        /* Poolcorp Custom Code */
        signInUrl: getPageLinkByPageType(state, "SignInPage")?.url,
        location: getLocation(state),
    }
};

const mapDispatchToProps = {
    loadExternalProviders,
};

/* Poolcorp Custom Code */
const enum fields {
    fullWidthButton = "fullWidthButton",
    title = "title",
    content = "content",
    isBoxed = "isBoxed",
}

interface FieldProps {
    [fields.fullWidthButton]: boolean;
    [fields.title]: string;
    [fields.content]: string;
    [fields.isBoxed]?: boolean;
}

export interface SignInExternalProvidersProps {
    fields: FieldProps;
    extendedStyles?: SignInExternalProvidersStyles;
    overrideStyles?: SignInExternalProvidersStyles;
    infosBoxProps?: InfosBoxPartialProps;
}

export interface SignInExternalProvidersPartialProps extends Omit<SignInExternalProvidersProps, "fields"> {
    fields?: Partial<FieldProps>;
}

type OwnProps = SignInExternalProvidersProps & WidgetProps;
/* Poolcorp Custom Code */

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>; // Poolcorp Custom Code

export interface SignInExternalProvidersStyles {
    divider?: InjectableCss;
    titleText?: TypographyPresentationProps;
    providerButton?: ButtonPresentationProps;
    // Poolcorp Custom Code
    container?: InjectableCss;
    boxedContainer?: InjectableCss;
    loadingOverlay?: LoadingOverlayProps;
    errorMessageText?: TypographyPresentationProps;
}

export const signInExternalProvidersStyles: SignInExternalProvidersStyles = {
    divider: {
        css: css`
            margin: 30px 0 20px 0;
        `,
    },
    titleText: {
        forwardAs: "h3",
        weight: "bold",
    },
    container: {
        css: css`
            ${contentSpacingStyles(TYPOGRAPHY.spacing.large, TYPOGRAPHY.spacing.large)}
            padding: ${TYPOGRAPHY.spacing.large} 0;
            border-top: 1px solid ${getColor("common.border")};
            border-bottom: 1px solid ${getColor("common.border")};

            &:first-child {
                padding-top: 0;
                border-top: 0;
            }

            &:last-child {
                padding-bottom: 0;
                border-bottom: 0;
            }
        `,
    },
    boxedContainer: {
        css: css`
            ${sideBoxStyles()}
            ${contentSpacingStyles(TYPOGRAPHY.spacing.large, TYPOGRAPHY.spacing.large)}
        `,
    },
    loadingOverlay: getLoadingOverlayProps(),
    errorMessageText: {
        color: "danger",
    },
};

// Poolcorp Removed Code - const styles = signInExternalProvidersStyles;
const SignInExternalProviders = ({
    externalProviders,
    loadExternalProviders,
    signInUrl, 
    location, 
    fields,
    // Poolcorp Custom Code
    extendedStyles,
    overrideStyles,
    infosBoxProps,
    externalError,
}: Props) => {
    /* Poolcorp Custom Code */
    const [errorMessage] = useState(externalError || "");
    const [styles] = useState(() =>
        Object.assign(mergeToNew(signInExternalProvidersStyles, extendedStyles), overrideStyles),
    );

    useEffect(() => {
        loadExternalProviders();
    }, []);
    /* Poolcorp Custom Code */

    const providerButtonClickHandler = (externalProvider: ExternalProviderLinkModel) => {
        /* Poolcorp Custom Code - Removed opti's returnUrl feature since our custom one handles PLP filters */
        if (externalProvider.url) {
            window.location.href = externalProvider.url;
        }
        /* Poolcorp Custom Code */
    };

    /* Poolcorp Removed - return null */

    const providerButtonCss = css`
        margin: 0;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    width: 100%;
                `,
                css`
                    width: 100%;
                `,
                fields.fullWidthButton
                    ? css`
                        width: 100%;
                    `
                    : null,
                fields.fullWidthButton
                    ? css`
                        width: 100%;
                    `
                    : null,
                fields.fullWidthButton
                    ? css`
                        width: 100%;
                    `
                    : null,
            ])}
    `;

    /* Poolcorp Custom Code */
    const isLoading = !externalProviders;
    const _infosBoxProps = {
        ...infosBoxProps,
        fields: {
            showIcon: true,
            content: translate("Sign-in providers are currently unavailable."),
            ...infosBoxProps?.fields,
        },
    };

    return (
        <StyledWrapper {...(fields.isBoxed ? styles.boxedContainer : styles.container)}>
            <LoadingOverlay loading={isLoading} {...styles.loadingOverlay}>
                <Typography {...styles.errorMessageText}>
                    {translate(errorMessage)}
                </Typography>
                {fields.title && <Typography {...styles.titleText}>{fields.title}</Typography>}
                {fields.content && parse(fields.content, parserOptions)}
                {!isLoading ? (
                    <StyledWrapper>
                        {externalProviders?.length ? (
                            externalProviders.map(externalProvider => (
                                <Button
                                    {...styles.providerButton}
                                    css={providerButtonCss}
                                    key={externalProvider.caption}
                                    onClick={() => providerButtonClickHandler(externalProvider)}
                                >
                                    {externalProvider.caption}
                                </Button>
                            ))
                        ) : (
                            <InfosBox {..._infosBoxProps} />
                        )}
                    </StyledWrapper>
                ) : null}
            </LoadingOverlay>
        </StyledWrapper>
    );
    /* Poolcorp Custom Code */
};

// Poolcorp Removed Code - Divider declaration

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(SignInExternalProviders),
    definition: {
        allowedContexts: ["SignInPage", "SignInOverlay"],
        group: "Sign In",
        displayName: "External Providers",
        fieldDefinitions: [
            {
                name: fields.fullWidthButton,
                displayName: "Full Width Button",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "General",
                sortOrder: 0,
            },
            /* Poolcorp Custom Code */
            {
                name: fields.title,
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "Translatable",
            },
            {
                name: fields.content,
                displayName: "Content",
                editorTemplate: "RichTextField",
                defaultValue: "",
                fieldType: "Contextual",
            },
            {
                name: fields.isBoxed,
                displayName: "Add a Box",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
                sortOrder: 1,
            },
            /* Poolcorp Custom Code */
        ],
    },
};

export default widgetModule;
